import { Box, Button, Center, Text } from "native-base";
import React from "react";

import ExternalImage from "../ExternalImage";

type BannerImageProps = {
  imageUrl: string;
  title?: string;
  alt?: string;
  width?: string;
  onPress: () => void;
};

const BannerImage = ({ alt, title, imageUrl, onPress, width = "280px" }: BannerImageProps) => {
  return (
    <Button
      variant="ghost"
      p={0}
      h="120px"
      w={width}
      m="2"
      borderRadius="10px"
      onPress={() => onPress()}>
      <Box h="120px" w={width} justifyContent="center" alignItems="center">
        <ExternalImage width="100%" height="100%" borderRadius={10} source={{ uri: imageUrl }} />
        {title && (
          <Center
            position="absolute"
            w="100%"
            h="100%"
            bgColor="rgba(0,0,0,.2)"
            borderRadius="10px">
            <Text fontSize="3xl" color="white.50" opacity={1} p="2" bold isTruncated>
              {title}
            </Text>
          </Center>
        )}
      </Box>
    </Button>
  );
};

export default BannerImage;
